"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _Hint = _interopRequireDefault(require("../../Hint"));

var Styled = _interopRequireWildcard(require("./Checkbox.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CheckboxInput = function CheckboxInput(_a) {
  var defaultChecked = _a.defaultChecked,
      field = _a.field,
      hint = _a.hint,
      id = _a.id,
      label = _a.label,
      name = _a.name,
      value = _a.value,
      props = (0, _tslib.__rest)(_a, ["defaultChecked", "field", "hint", "id", "label", "name", "value"]);
  return _react.default.createElement(Styled.CheckboxContainer, null, _react.default.createElement(Styled.Input, (0, _tslib.__assign)({
    "data-testid": "checkbox__" + id,
    defaultChecked: defaultChecked,
    id: id,
    type: "checkbox"
  }, field, {
    name: (field === null || field === void 0 ? void 0 : field.name) || name,
    value: (field === null || field === void 0 ? void 0 : field.value) || value || id
  }, props)), _react.default.createElement(Styled.Checkbox, {
    alignItems: "center",
    color: "orange",
    justifyContent: "center"
  }, _react.default.createElement(_reactFeather.Check, {
    strokeWidth: "5"
  })), _react.default.createElement(Styled.CheckboxLabel, {
    htmlFor: id
  }, _react.default.createElement("span", null, label, props.required && '*'), hint && _react.default.createElement(_Hint.default, null, hint)));
};

CheckboxInput.displayName = 'CheckboxInput';
CheckboxInput.defaultProps = {
  defaultChecked: false
};
var _default = CheckboxInput;
exports.default = _default;